import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { User } from "./classes/User";
import { AuthService } from "./services/auth.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Location } from '@angular/common';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  user: User;
  loading = true;
  userHover: boolean;
  showHeader: boolean;

  params: any = {};

  err = "";

  origPath;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loc: Location,
    private auth: AuthService
  ) { }

  ngOnInit() {
   this.route.queryParams.subscribe((params) => {
      // console.log("Params => ", params);
      let keys = Object.keys(params);
      this.origPath = this.loc.path().split("?")[0];
      if (keys.length) {
        for (let k of keys) {
          if (k === "ver" || this.origPath != "/support") continue;
          else this.params[k] = params[k];
        }
      }
      this.versionCheck();
    });
  }

  versionCheck() {
    this.auth.getCurrentVersion().subscribe(
      (res: string) => {
        let ver = localStorage.getItem("api_version");
        if (ver !== res) {
          localStorage.setItem("api_version", res);
          let p = "";
          let keys = Object.keys(this.params);
          for (let k of keys) {
            p = `${p}&${k}=${this.params[k]}`;
          }
          let loc = window.location;
          window.location.href = `${loc.origin}${loc.pathname}?ver=${res}${p}`;
        } else {
          this.loading = false;
        }
      },
      (err) => (this.err = err.error.detail)
    );
  }
}
